import {connect} from 'react-redux';

import * as TestActions from '../../store/actions/testActions';
import Test from '../../components/UserCourse/Test';
import * as VideoActions from '../../store/actions/videoActions';
import * as AuthActions from '../../store/actions/authActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.test,
    ...state.courses,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    getUserTestCopy: (testId, profileId, token) => {
        dispatch(TestActions.requestTest(testId, profileId, token));
    },
    onLoad: (id, profileId, token) => {
        // console.log("onloading", id, profileId, token);
        dispatch(VideoActions.getUserLecture(id, profileId, token));
    },
    onLoadOld: (id, token, courseUser, subjectAttempt, courseAttempt, us, profileId, userId) => {
        dispatch(VideoActions.getUserLecture(id, courseUser,  subjectAttempt, courseAttempt, us, token));
    },
    updateTest: (test, token) => {
        // console.log("Updating", test);
        if(test.chapterVideoId){
            dispatch(TestActions.updateSubjectTest(test, token));
        }else{
            dispatch(TestActions.updateTest(test, token));
        }
        
    },
    scoreTest: (test, profileId, token) => {
        dispatch(TestActions.scoreTest(test, profileId, token));
    },
    scoreSubjectTest: (test, profileId, token) => {
        
        dispatch(TestActions.scoreSubjectTest(test, profileId, token));
    },
    getSubjectTestCopy: (testId, profileId, token) => {
        dispatch(TestActions.requestSubjectTest(testId, profileId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));
    },
    nextChapterPart: (courseUser, token) => {
        dispatch(AuthActions.setCourseUserNextStep(courseUser, token));
    },
    createCourseNotification: (note, token) => {
        dispatch(VideoActions.createCourseNotification(note, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Test);


// WEBPACK FOOTER //
// ./src/containers/UserCourse/TestContainer.js